import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, from, of } from 'rxjs';
import { catchError, filter, switchMap, take, finalize } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    if (request.url.endsWith('logar') || request.url.endsWith('renovar-token')) {
      return next.handle(request);
    }

    let token: string | null;
    
    try {
      token = this.authService.getToken();
    } catch (error) {
      console.error('Erro ao obter token:', error);
      return throwError(() => error);
    }
    
    if (token) {
      request = this.addToken(request, token);
      try {
        this.authService.verificarTokenExpiracao();
      } catch (error) {
        console.error('Erro ao verificar expiração do token:', error);
        return throwError(() => error);
      }
    }
    
    return next.handle(request).pipe(
      catchError(error => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next);
        }
        return throwError(() => error);
      })
    );
  }
  
  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  
  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      
      return from(this.authService.renovarToken()).pipe(
        switchMap(success => {
          if (success) {
            this.refreshTokenSubject.next(true);
            return next.handle(this.addToken(request, this.authService.getToken() || ''));
          } else {
            this.authService.logout();
            return throwError(() => new Error('Sessão expirada'));
          }
        }),
        catchError(error => {
          console.error('Erro ao renovar token:', error);
          
          this.authService.logout();          
          return throwError(() => error);
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    }
    
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(() => next.handle(this.addToken(request, this.authService.getToken() || ''))),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
}